import { render } from "./OrderForm.vue?vue&type=template&id=6f58e0a3&scoped=true&ts=true"
import script from "./OrderForm.vue?vue&type=script&lang=ts"
export * from "./OrderForm.vue?vue&type=script&lang=ts"

import "./OrderForm.vue?vue&type=style&index=0&id=6f58e0a3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f58e0a3"]])

export default __exports__